import Vue from 'vue';
import VueOffline from 'vue-offline';

declare module 'vue/types/vue' {
  interface Vue {
    readonly isOnline: boolean;
    readonly isOffline: boolean;
    readonly $offlineStorage: VueOfflineStorageInterface;
  }
}

Vue.use(VueOffline, {
  storage: false
});
